/**
 * フッターWeb Component
 * - フッターナビゲーション
 * - ソーシャルリンク
 * - 法的情報
 * - 多言語対応
 */

// 翻訳定数オブジェクト
const FOOTER_TRANSLATIONS = {
  ja: {
    about: 'VONSAIとは',
    findBonsai: '盆栽を探す',
    masters: '盆栽師を知る',
    investmentGuide: '盆栽所有ガイド',
    services: '提供サービス',
    helpfulGuide: 'お役立ちガイド',
    news: 'お知らせ',
    faq: 'よくあるご質問',
    contact: 'お問い合わせ',
    delivery: '配送について',
    returnPolicy: '返品規約について',
    termsMember: '会員規約',
    termsUse: 'サイト利用規約',
    specifiedTrade: '特定商取引法に基づく表記',
    company: '運営会社',
    privacy: 'プライバシーポリシー',
    copyright: '© Bonsai Inc. All rights reserved',
    logoText: '盆栽コレクション'
  },
  en: {
    about: 'About VONSAI',
    findBonsai: 'Find Bonsai',
    masters: 'Meet the Masters',
    investmentGuide: 'VONSAI Guide',
    services: 'Services',
    helpfulGuide: 'Helpful Guide',
    news: 'News',
    faq: 'FAQ',
    contact: 'Contact',
    delivery: 'Shipping',
    returnPolicy: 'Return Policy',
    termsMember: 'Member Terms',
    termsUse: 'Terms of Use',
    specifiedTrade: 'Legal Notice',
    company: 'Company',
    privacy: 'Privacy Policy',
    copyright: '© Bonsai Inc. All rights reserved',
    logoText: 'Bonsai Collection Platform'
  },
  'zh-cn': {
    about: '关于VONSAI',
    findBonsai: '寻找盆景',
    masters: '认识盆景师',
    investmentGuide: 'VONSAI指南',
    services: '服务',
    helpfulGuide: '实用指南',
    news: '新闻',
    faq: '常见问题',
    contact: '联系我们',
    delivery: '配送信息',
    returnPolicy: '退货政策',
    termsMember: '会员条款',
    termsUse: '使用条款',
    specifiedTrade: '法律声明',
    company: '公司信息',
    privacy: '隐私政策',
    copyright: '© Bonsai Inc. 版权所有',
    logoText: '盆景收藏平台'
  },
  'zh-tw': {
    about: '關於VONSAI',
    findBonsai: '尋找盆景',
    masters: '認識盆景師',
    investmentGuide: 'VONSAI指南',
    services: '服務',
    helpfulGuide: '實用指南',
    news: '消息',
    faq: '常見問題',
    contact: '聯絡我們',
    delivery: '配送資訊',
    returnPolicy: '退貨政策',
    termsMember: '會員條款',
    termsUse: '使用條款',
    specifiedTrade: '法律聲明',
    company: '公司資訊',
    privacy: '隱私政策',
    copyright: '© Bonsai Inc. 版權所有',
    logoText: '盆景收藏平台'
  },
  ko: {
    about: 'VONSAI 소개',
    findBonsai: '분재 찾기',
    masters: '장인 만나기',
    investmentGuide: 'VONSAI 가이드',
    services: '서비스',
    helpfulGuide: '유용한 가이드',
    news: '소식',
    faq: '자주 묻는 질문',
    contact: '문의하기',
    delivery: '배송 정보',
    returnPolicy: '반품 정책',
    termsMember: '회원 약관',
    termsUse: '이용 약관',
    specifiedTrade: '법적 고지',
    company: '회사 정보',
    privacy: '개인정보 보호정책',
    copyright: '© Bonsai Inc. All rights reserved',
    logoText: '분재 컬렉션 플랫폼'
  },
  fr: {
    about: 'À propos de VONSAI',
    findBonsai: 'Trouver un bonsaï',
    masters: 'Rencontrer les maîtres',
    investmentGuide: 'Guide VONSAI',
    services: 'Services',
    helpfulGuide: 'Guide utile',
    news: 'Actualités',
    faq: 'FAQ',
    contact: 'Contact',
    delivery: 'Livraison',
    returnPolicy: 'Politique de retour',
    termsMember: 'Conditions d\'adhésion',
    termsUse: 'Conditions d\'utilisation',
    specifiedTrade: 'Mentions légales',
    company: 'Entreprise',
    privacy: 'Politique de confidentialité',
    copyright: '© Bonsai Inc. Tous droits réservés',
    logoText: 'Plateforme de collection bonsaï'
  },
  de: {
    about: 'Über VONSAI',
    findBonsai: 'Bonsai finden',
    masters: 'Meister kennenlernen',
    investmentGuide: 'VONSAI-Leitfaden',
    services: 'Dienstleistungen',
    helpfulGuide: 'Nützlicher Leitfaden',
    news: 'Nachrichten',
    faq: 'FAQ',
    contact: 'Kontakt',
    delivery: 'Versand',
    returnPolicy: 'Rückgaberichtlinien',
    termsMember: 'Mitgliedsbedingungen',
    termsUse: 'Nutzungsbedingungen',
    specifiedTrade: 'Impressum',
    company: 'Unternehmen',
    privacy: 'Datenschutz',
    copyright: '© Bonsai Inc. Alle Rechte vorbehalten',
    logoText: 'Bonsai-Kollektionsplattform'
  },
  es: {
    about: 'Acerca de VONSAI',
    findBonsai: 'Encontrar bonsái',
    masters: 'Conocer a los maestros',
    investmentGuide: 'Guía VONSAI',
    services: 'Servicios',
    helpfulGuide: 'Guía útil',
    news: 'Noticias',
    faq: 'Preguntas frecuentes',
    contact: 'Contacto',
    delivery: 'Envío',
    returnPolicy: 'Política de devoluciones',
    termsMember: 'Términos de membresía',
    termsUse: 'Términos de uso',
    specifiedTrade: 'Aviso legal',
    company: 'Empresa',
    privacy: 'Política de privacidad',
    copyright: '© Bonsai Inc. Todos los derechos reservados',
    logoText: 'Plataforma de colección de bonsái'
  },
  ar: {
    about: 'حول VONSAI',
    findBonsai: 'البحث عن بونساي',
    masters: 'لقاء المعلمين',
    investmentGuide: 'دليل VONSAI',
    services: 'خدماتنا',
    helpfulGuide: 'دليل مفيد',
    news: 'أخبار',
    faq: 'الأسئلة الشائعة',
    contact: 'اتصل بنا',
    delivery: 'معلومات الشحن',
    returnPolicy: 'سياسة الإرجاع',
    termsMember: 'شروط العضوية',
    termsUse: 'شروط الاستخدام',
    specifiedTrade: 'قانون المعاملات التجارية المحددة',
    company: 'الشركة',
    privacy: 'سياسة الخصوصية',
    copyright: '© Bonsai Inc. جميع الحقوق محفوظة',
    logoText: 'منصة مجموعة البونساي'
  }
};

/**
 * 現在のロケールを検出
 * @returns {string} ロケールコード (例: 'ja', 'en', 'zh-cn')
 */
function detectLocaleFooter() {
  // 方法1: URLパスから検出 (例: /ja/pages/about, /en/pages/about)
  const pathMatch = window.location.pathname.match(/^\/([a-z]{2}(-[a-z]{2})?)\//i);
  if (pathMatch) {
    return pathMatch[1].toLowerCase();
  }

  // 方法2: <html lang="ja"> 属性から検出
  const htmlLang = document.documentElement.lang;
  if (htmlLang) {
    return htmlLang.toLowerCase();
  }

  // 方法3: クエリパラメータから検出 (例: ?locale=en)
  const urlParams = new URLSearchParams(window.location.search);
  const localeParam = urlParams.get('locale');
  if (localeParam) {
    return localeParam.toLowerCase();
  }

  // デフォルト: 日本語
  return 'ja';
}

/**
 * ローカライズされたURLを生成
 * @param {string} path - パス (例: '/pages/about')
 * @param {string} locale - ロケールコード
 * @returns {string} ローカライズされたURL
 */
function getLocalizedUrlFooter(path, locale) {
  // locale が ja の場合はプレフィックスなし、それ以外は /en, /zh-cn などを追加
  if (locale === 'ja') {
    return `https://vonsai.tokyo${path}`;
  }
  return `https://vonsai.tokyo/${locale}${path}`;
}

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    // 言語を検出し、翻訳を選択
    this.locale = detectLocaleFooter();
    this.translations = FOOTER_TRANSLATIONS[this.locale] || FOOTER_TRANSLATIONS['ja'];
  }

  connectedCallback() {
    this.innerHTML = this.getTemplate();
  }

  getTemplate() {
    return `
      <footer class="l-footer">
        <div class="l-inner">
          <!-- フッターメインコンテンツ -->
          <div class="l-footer__main">
            <!-- ロゴとSNSセクション -->
            <div class="l-footer__brand">
              <div class="l-footer__brand-content">
                <a href="${getLocalizedUrlFooter('/', this.locale)}">
                  <img src="https://cdn.shopify.com/s/files/1/0713/0821/4409/files/logo.svg?v=1754382576" alt="VONSAI ${this.translations.logoText}" width="158" height="47" loading="lazy" class="l-footer__logo">
                  <p class="l-footer__logo__text">${this.translations.logoText}</p>
                </a>
                <div class="l-footer__social">
                  <a href="https://www.instagram.com/bonsai___tokyo/?igsh=eWxuc2dsbHd6MzRj&utm_source=qr" target="_blank" class="l-footer__social-link" aria-label="Instagram">
                    <svg viewBox="0 0 20 20" width="20" height="20" role="img">
                      <path d="M10 1.8c2.67 0 2.99.01 4.04.06 1.03.05 1.59.22 1.96.37.49.19.84.42 1.21.79.37.37.6.72.79 1.21.15.37.32.93.37 1.96.05 1.05.06 1.37.06 4.04s-.01 2.99-.06 4.04c-.05 1.03-.22 1.59-.37 1.96-.19.49-.42.84-.79 1.21-.37.37-.72.6-1.21.79-.37.15-.93.32-1.96.37-1.05.05-1.37.06-4.04.06s-2.99-.01-4.04-.06c-1.03-.05-1.59-.22-1.96-.37-.49-.19-.84-.42-1.21-.79-.37-.37-.6-.72-.79-1.21-.15-.37-.32-.93-.37-1.96C1.81 12.99 1.8 12.67 1.8 10s.01-2.99.06-4.04c.05-1.03.22-1.59.37-1.96.19-.49.42-.84.79-1.21.37-.37.72-.6 1.21-.79.37-.15.93-.32 1.96-.37C7.01 1.81 7.33 1.8 10 1.8M10 0C7.28 0 6.94.01 5.88.07 4.82.12 4.1.3 3.45.57c-.68.26-1.26.61-1.84 1.19C1.03 2.34.68 2.92.42 3.6.15 4.25-.03 4.97.02 6.03.08 7.09.09 7.43.09 10.19s.01 3.1.07 4.16c.05 1.06.23 1.78.5 2.43.26.68.61 1.26 1.19 1.84.58.58 1.16.93 1.84 1.19.65.27 1.37.45 2.43.5 1.06.06 1.4.07 4.16.07s3.1-.01 4.16-.07c1.06-.05 1.78-.23 2.43-.5.68-.26 1.26-.61 1.84-1.19.58-.58.93-1.16 1.19-1.84.27-.65.45-1.37.5-2.43.06-1.06.07-1.4.07-4.16s-.01-3.1-.07-4.16c-.05-1.06-.23-1.78-.5-2.43-.26-.68-.61-1.26-1.19-1.84C16.74 1.03 16.16.68 15.48.42 14.83.15 14.11-.03 13.05.02 11.99.08 11.65.09 8.89.09L10 0z" fill="#ffffff"/>
                      <path d="M10 4.86A5.14 5.14 0 1 0 15.14 10 5.14 5.14 0 0 0 10 4.86zM10 13.51A3.51 3.51 0 1 1 13.51 10 3.51 3.51 0 0 1 10 13.51z" fill="#ffffff"/>
                      <circle cx="15.38" cy="4.62" r="1.2" fill="#ffffff"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            <!-- ナビゲーションリンク -->
            <nav class="l-footer__nav">
              <ul class="l-footer__nav-list">
                <li class="l-footer__nav-item"><a href="${getLocalizedUrlFooter('/pages/about', this.locale)}" class="l-footer__nav-link">${this.translations.about}</a></li>
                <li class="l-footer__nav-item"><a href="${getLocalizedUrlFooter('/collections/all', this.locale)}" class="l-footer__nav-link">${this.translations.findBonsai}</a></li>
                <li class="l-footer__nav-item"><a href="${getLocalizedUrlFooter('/pages/masters', this.locale)}" class="l-footer__nav-link">${this.translations.masters}</a></li>
              </ul>
              <ul class="l-footer__nav-list">
                <li class="l-footer__nav-item"><a href="${getLocalizedUrlFooter('/pages/flow', this.locale)}" class="l-footer__nav-link">${this.translations.investmentGuide}</a></li>
                <li class="l-footer__nav-item"><a href="${getLocalizedUrlFooter('/pages/own-log', this.locale)}" class="l-footer__nav-link">${this.translations.services}</a></li>
                <li class="l-footer__nav-item"><a href="${getLocalizedUrlFooter('/blogs/guide', this.locale)}" class="l-footer__nav-link">${this.translations.helpfulGuide}</a></li>
              </ul>
              <ul class="l-footer__nav-list">
                <li class="l-footer__nav-item"><a href="${getLocalizedUrlFooter('/blogs/news', this.locale)}" class="l-footer__nav-link">${this.translations.news}</a></li>
                <li class="l-footer__nav-item"><a href="${getLocalizedUrlFooter('/pages/faq', this.locale)}" class="l-footer__nav-link">${this.translations.faq}</a></li>
                <li class="l-footer__nav-item"><a href="${getLocalizedUrlFooter('/pages/contact', this.locale)}" class="l-footer__nav-link">${this.translations.contact}</a></li>
                <li class="l-footer__nav-item"><a href="${getLocalizedUrlFooter('/pages/faq#delivery', this.locale)}" class="l-footer__nav-link">${this.translations.delivery}</a></li>
              </ul>
              <ul class="l-footer__nav-list">
                <li class="l-footer__nav-item"><a href="${getLocalizedUrlFooter('/pages/faq#return', this.locale)}" class="l-footer__nav-link">${this.translations.returnPolicy}</a></li>
                <li class="l-footer__nav-item"><a href="${getLocalizedUrlFooter('/policies/terms-of-service#account', this.locale)}" class="l-footer__nav-link">${this.translations.termsMember}</a></li>
                <li class="l-footer__nav-item"><a href="${getLocalizedUrlFooter('/policies/terms-of-service', this.locale)}" class="l-footer__nav-link">${this.translations.termsUse}</a></li>
                <li class="l-footer__nav-item"><a href="${getLocalizedUrlFooter('/policies/legal-notice', this.locale)}" class="l-footer__nav-link">${this.translations.specifiedTrade}</a></li>
              </ul>
            </nav>
          </div>
          <div class="l-footer__bottom">
            <div class="l-footer__copyright">
              ${this.translations.copyright}
            </div>
            <!-- 法的情報 -->
            <div class="l-footer__legal">
              <a href="https://bon-sai.tokyo/" target="_blank" class="l-footer__legal-link">${this.translations.company}</a>
              <a href="${getLocalizedUrlFooter('/policies/privacy-policy', this.locale)}" class="l-footer__legal-link">${this.translations.privacy}</a>
            </div>
          </div>
        </div>
      </footer>
    `;
  }
}

// Web Componentを定義
customElements.define('vonsai-footer', FooterComponent);
